import { useEffect, useState } from "react";
import { API_URL } from "../infra/settings";

export function useCurrentEventDay(): string | null {
  const [currentDay, setCurrentDay] = useState<string | null>(null);

  useEffect(() => {
    const fetchDay = () =>
      fetch(`${API_URL}/v1/events/current-day`)
        .then((res) => res.json())
        .then((data) => setCurrentDay(data.current_day_label ?? null))
        .catch(() => {});

    fetchDay();
    const interval = setInterval(fetchDay, 5000);
    return () => clearInterval(interval);
  }, []);

  return currentDay;
}
